import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "welcome-to-chawkbazar"
    }}>{`Welcome to Chawkbazar`}</h1>
    <p>{`Welcome to the ChawkBazar Laravel documentation! Fastest Ecommerce App built with React, NextJS, TypeScript, Laravel and Tailwind CSS.`}</p>
    <h2 {...{
      "id": "navigation"
    }}>{`Navigation`}</h2>
    <p>{`You can find different topics in the table of contents. On desktop, you should see it in the left sidebar. On mobile, you should see it after pressing an icon with Hamberger in the top right corner.`}</p>
    <h2 {...{
      "id": "supported-platforms--ecosystem-for-local-development"
    }}>{`Supported platforms & ecosystem for local development`}</h2>
    <ul>
      <li parentName="ul">{`Compatible Browsers (Firefox, Safari, Chrome, Edge)`}</li>
      <li parentName="ul">{`Node.js 20.0.0 or later(`}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`PHP 8.1`}</li>
      <li parentName="ul">{`MySQL 8`}</li>
      <li parentName="ul">{`MacOS, Windows, and Linux are supported`}</li>
    </ul>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`Node.js 20.0.0 or later(`}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`yarn`}</li>
      <li parentName="ul">{`PHP 8.1`}</li>
      <li parentName="ul">{`MySQL 8`}</li>
      <li parentName="ul">{`ext_curl`}</li>
      <li parentName="ul">{`ext_gmp`}</li>
      <li parentName="ul">{`editor: `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{`(recommended)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      